import { render } from "./BasePreloader.vue?vue&type=template&id=44c898cc&scoped=true"
import script from "./BasePreloader.vue?vue&type=script&lang=js"
export * from "./BasePreloader.vue?vue&type=script&lang=js"

import "./BasePreloader.vue?vue&type=style&index=0&id=44c898cc&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c898cc"]])

export default __exports__